import {
  GET_MESSAGES_SUCCESS,
  GET_MESSAGES_FAILURE,
  GET_MESSAGES_BEGIN,
  GET_CONVERSATION_SUCCESS,
  GET_CONVERSATION_BEGIN,
  GET_CONVERSATION_FAILURE,
  SEND_MESSAGE_ERROR,
  DELETE_MESSAGE_ERROR,
  UPDATE_MESSAGE_LIST,
} from 'actions/types/messageTypes.js';

const initialState = {
  fetchingMessages: false,
  fetchingConversation: false,
  messages: null,
  conversation: null,
  error: null,
};

const MessagesReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_MESSAGES_BEGIN:
      return {
        ...state,
        ...payload,
      };
    case GET_MESSAGES_SUCCESS:
      return {
        ...state,
        ...payload,
      };
    case GET_MESSAGES_FAILURE:
      return {
        ...state,
        ...payload,
      };
    case GET_CONVERSATION_BEGIN:
      return {
        ...state,
        ...payload,
      };
    case GET_CONVERSATION_SUCCESS:
      return {
        ...state,
        ...payload,
      };
    case GET_CONVERSATION_FAILURE:
      return {
        ...state,
        ...payload,
      };
    case SEND_MESSAGE_ERROR:
      return {
        ...state,
        ...payload,
      };
    case DELETE_MESSAGE_ERROR:
      return {
        ...state,
        ...payload,
      };
    case UPDATE_MESSAGE_LIST: {
      const existingResults = state.messages?.results || [];
      const newConversations = payload.filter(
        (item) =>
          !existingResults.some(
            (message) => message.sender.id === item.sender.id,
          ),
      );
      return {
        ...state,
        messages: {
          ...state.messages,
          results: [
            ...newConversations,
            ...existingResults.map(
              (message) =>
                payload.find((item) => item.sender.id === message.sender.id) ||
                message,
            ),
          ],
        },
      };
    }
    default:
      return state;
  }
};

export default MessagesReducer;
